// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"290":"forum/components/WikiShowPage","553":"forum/components/WikiComposePage","873":"forum/components/WikiIndexPage"}[chunkId] + ".js";
};